<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div class="user-main-right">
        <div class="info-title">
          <span>我的直播课</span>
          <a :href="course_accessory" download="fff" target="_blank" style="font-size: 16px">
            资料下载
            <i>
              <img src="../../../static/images/zmr-images/down.png" alt="">
            </i>
          </a>
        </div>
        <ul class="timetable-list">
          <li>
            <div class="timetable-list-item-top">
              <span>课程编号：{{onlinelist.course_num}}</span>
            </div>
            <div class="timetable-list-item-bottom">
              <div class="name">
                <span><img :src="onlinelist.course_pic" :onerror="errorImg01" width="100%" height="100%"></span>
                <div class="timetable-txt">
                  <h3>{{onlinelist.course_name}}</h3>
                  <p>直播课</p>
                </div>
              </div>

              <div class="time">
                <span>{{onlinelist.live_start_time}}至{{onlinelist.live_end_time}}</span>
              </div>

              <div class="status">
                <p class="look-time-txt">{{onlinelist.status}}</p>
              </div>

              <div class="teacher">
                <span class="teacher-img"><img :src="teacher_info.teacher_pic" width="100%" height="100%"></span>
                <p class="teacher-txt">教师：{{teacher_info.teacher_name}}</p>
              </div>
            </div>
          </li>
        </ul>
        <ul class="timetable-list-bot">
          <li v-for="(item,index) of lessons_info">
            <a :href="item.lessons_link">
              <div style="display: flex;align-items: center;">
                <span class="syy-download">{{item.lessons_name}}</span>
                <span>课程{{index+1}}</span>
              </div>
              <span style="color: #b5b5b5;font-size: 14px">{{item.start_time}}</span>
            </a>
          </li>
        </ul>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/js/tool'
  import videoPlay from './record-video-play'

  export default {
    name: "user-Livedetail",
    data() {
      return {
        errorImg01:'this.src="' + require('../../../static/images/zmr-images/default.jpg') + '"',
        navActive: 3,
        userNav: 5,
        course_id: this.$route.query.course_id,//课程id
        onlinelist: Object,//课程信息
        teacher_info: Object,//教师信息
        lessons_info: Array,//课节信息
        course_accessory:''
      }
    },
    components: {
      UserNav,
      navCom,
      footerCom
    },
    methods: {
      getMy_Coursedet() {
        let data = {
          user_id: this.$store.state.uuid,
          course_id: this.course_id,
        };
        tool.postData('Center_My_Course/liveCourseDetails', data, (res) => {
          console.log(res.data.data)
          this.onlinelist = res.data.data;
          this.teacher_info = res.data.data.teacher_info;
          this.lessons_info = res.data.data.lessons_info;
          this.course_accessory=res.data.data.course_accessory;
        })
      }
    },
    mounted() {
      this.getMy_Coursedet()
    }
  }
</script>

<style scoped>
  .w {
    width: 1200px;
    margin: 0 auto;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .all-whole {
    background: #fbfbfb;
  }

  .timetable-list-bot .syy-download {
    font-size: 16px;
    color: #1970ff;
  }

  .timetable-list-bot span:last-child {
    padding-left: 16px;
    font-size: 16px;
    color: #000;
  }

  .timetable-list-bot {
    margin-top: 9px;
  }

  .timetable-list-bot li {
    border-bottom: 1px solid #e3e3e3;
    cursor: pointer;
    width: 954px;
    height: 51px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .timetable-list-bot li a{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 954px;
  }
  .user-main-right {
    width: 1000px;
    float: right;
    height: 896px;
    background: #ffffff;
  }

  .info-title {
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    color: #252525;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
  }

  .info-title > span {
    font-size: 16px;
  }

  .info-title > p {
    font-size: 14px;
    cursor: pointer;
  }

  .timetable-list {
    margin-top: 30px;
  }

  .timetable-list li {
    border: 1px solid #e3e3e3;
    cursor: pointer;
    width: 954px;
    height: 213px;
    margin: 0 auto 26px;
  }

  .timetable-list-item-top {
    width: 100%;
    background: #f3f3f3;
    height: 48px;
    border-bottom: 1px solid #e3e3e3;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }

  .timetable-list-item-top span {
    font-size: 16px;
    color: #3a3a3a;
    font-weight: 500;
    line-height: 48px;
  }

  .timetable-list-item-top span:last-child {
    text-align: right;
  }

  .timetable-list-item-bottom {
    font-size: 0;
  }

  .timetable-list-item-bottom .name {
    width: 350px;
    height: 165px;
    display: inline-block;
    padding: 28px 15px;
    box-sizing: border-box;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
    position: relative;
  }

  .timetable-list-item-bottom .name span {
    width: 99px;
    height: 99px;
    display: inline-block;
  }

  .timetable-txt {
    display: inline-block;
    vertical-align: top;
    margin-left: 15px;
  }

  .timetable-txt h3 {
    color: #414141;
    font-size: 20px;
    font-weight: normal;
    line-height: 36px;
    margin-bottom: 15px;
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .timetable-txt p {
    font-size: 16px;
    color: #8c8c8c;
  }

  .timetable-list-item-bottom .time {
    width: 216px;
    height: 165px;
    line-height: 165px;
    display: inline-block;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
    box-sizing: border-box;
    text-align: center;
    overflow: auto
  }

  .timetable-list-item-bottom .time span {
    color: #8c8c8c;
    font-size: 16px;
    line-height: 40px;
    vertical-align: middle;
    display: inline-block;
  }

  .timetable-list-item-bottom .status {
    width: 220px;
    height: 165px;
    display: inline-block;
    text-align: center;
    border-right: 1px solid #e3e3e3;
    vertical-align: top;
  }

  .timetable-list-item-bottom .status p {
    font-size: 16px;
    line-height: 165px;
  }

  .look-time-txt {
    color: #1a71ff;
    font-size: 16px;
    text-align: center;
    margin-bottom: 18px;
  }

  .timetable-list-item-bottom .teacher {
    width: 158px;
    height: 165px;
    display: inline-block;
    padding: 30px 0;
    box-sizing: border-box;
    text-align: center;
    vertical-align: top;
  }

  .teacher-img {
    width: 47px;
    height: 47px;
    border-radius: 50%;
    overflow: hidden;
    display: block;
    margin: 10px auto 0;
  }

  .teacher-txt {
    font-size: 16px;
    color: #8c8c8c;
    margin-top: 17px;
    text-align: center;
  }

  .free_icon {
    padding: 2px 3px;
    font-size: 12px;
    color: #fff;
    background-color: #f10000;
    margin-left: 5px;
    border-radius: 2px;
    position: relative;
    top: -3px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/user-live-detail.vue